import TestimonialContents from "./TestimonialContent";
import { useEffect, useState } from "react";
import createClient from '../Client';

//slider with thumb images wrapper
const Testimonials = ()  => {
    const [reviewData, setReviewData] = useState([]);

    useEffect(() => {
        createClient.fetch(`*[_type=="testimonials"]{
              ...,
              "ThumbImage": testimonials_user_image.asset->url,
              "desc":testimonials_description,
              "modelImage": testimonials_carousel_image.asset->url
            }`).then((data) => {
          setReviewData(data);
          
        })
          .catch(console.error);
      }, [])
    return(
        <>
        <section className="testimonials p-top-70">
            <div className="container">
                <TestimonialContents></TestimonialContents>
            </div>
        </section>
        </>
    );
}

export default Testimonials;